import MinusCircleSolidSVG from "@design-system/ui-icons/vanilla/MinusCircleSolid"
import { createIcon } from "../createIcon"

export const MinusCircleSolidIcon = createIcon(MinusCircleSolidSVG)
